import gradePriceModel from "../atoms/grade-price.model"
import timeSlotModel from "../atoms/time-slot.model"
import { ID2 } from "../yup.common"
import { date, array, string, object, number } from "yup"
const demandModel = object({
  name: string().min(2).required().max(30).label("Demand Name"),
  dateRange: array(string())
    .min(2)
    .label("Demand Range")
    .required("Please fill out the demand date range!"),
  varietyGroup: ID2("Variety").required().label("Variety"),
  broadcastTime: date().label("Broadcast Time"),
  depot: ID2("Depot").required().label("Depot"),
  gradePrices: array(gradePriceModel).min(1).required().label("Grade Prices"),
  timeSlots: array(timeSlotModel).min(1).required().label("Time Slots"),
  groupVisibility: array().label("Group Visibility"),
  remark: string().max(150),
  companyVisibility: array().label("Company Visibility"),
  bookingQuantityLimit: number().label("Booking Limit"),
})

export default demandModel
